import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth11getGetScreenTruthTargetsResponseSchema = jsonObject
export type tcpscreentruth11getGetScreenTruthTargetsResponse = z.infer<typeof tcpscreentruth11getGetScreenTruthTargetsResponseSchema>
export const tcpscreentruth11getGetScreenTruthRequirementsSummaryResponseSchema = jsonObject
export type tcpscreentruth11getGetScreenTruthRequirementsSummaryResponse = z.infer<typeof tcpscreentruth11getGetScreenTruthRequirementsSummaryResponseSchema>
